/** Only display metadata is normalized here; configured method codes remain unchanged. */
function displayText(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function paymentIconUrl(value) {
  const text = displayText(value);
  if (!text) return '';
  try {
    const url = new URL(text);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
  } catch {
    return '';
  }
}

export function normalizeTopPayPresentation(row) {
  const source = row?.methodMeta;
  const entries = source && typeof source === 'object' && !Array.isArray(source);
  return {
    entryName: displayText(row?.entryName),
    entryDescription: displayText(row?.entryDescription),
    entryIconUrl: paymentIconUrl(row?.entryIconUrl),
    methodMeta: Object.fromEntries(
      (entries ? Object.entries(source) : []).map(([code, meta]) => [
        code,
        { name: displayText(meta?.name), iconUrl: paymentIconUrl(meta?.iconUrl) },
      ])
    ),
  };
}
